import {Nullable} from '../../../app/TypeHelpers'
import moment from 'moment/moment'
import {RESIDENT_STATUS} from '../../../CodeMaster'

export class Room {
    condominiumCd: string
    ridgeCd: string
    ridgeName: string
    roomNumber: string
    status: RESIDENT_STATUS
    abolitionDatetime: Nullable<moment.Moment>

    constructor(
        condominiumCd: string,
        ridgeCd: string,
        ridgeName: string,
        roomNumber: string,
        status: RESIDENT_STATUS,
        abolitionDatetime: Nullable<moment.Moment>
    ) {
        this.condominiumCd = condominiumCd
        this.ridgeCd = ridgeCd
        this.ridgeName = ridgeName
        this.roomNumber = roomNumber
        this.status = status
        this.abolitionDatetime = abolitionDatetime
    }

    static from(json: any): Room {
        return new Room(
            json.condominiumCd,
            json.ridgeCd,
            json.ridgeName,
            json.roomNumber,
            RESIDENT_STATUS.codeToEnumConstants(json.status),
            json.abolitionDatetime === null ? null : moment(json.abolitionDatetime),
        )
    }
}
